'use client';

import { usePathname } from 'next/navigation';
import Logotype from '@/components/Assets/Logotype/Logotype.Tagline';
import Box from '@/polymorphics/Box';
import Container from '@/polymorphics/Container';
import Flex from '@/polymorphics/Flex';
import Grid from '@/polymorphics/Grid';
import Image from '../Image';
import FooterBar from './Footer.Bar';
import FooterEntries from './Footer.Entries';
import * as styles from './Footer.css';
import Btn from '@/polymorphics/Btn';

type FooterClientProps = {
  footerNav: any;
  extrasNav: any;
  partnerMultiple: any;
  linkedin: any;
};

export default function FooterClient({ footerNav, extrasNav, partnerMultiple, linkedin }: FooterClientProps) {
  const pathname = usePathname();
  const isLandingPage = pathname?.includes('/squaretrade');

  if (isLandingPage) {
    return null;
  }

  return (
    <Container as="footer" colorTheme="dark" colorSet="primary" maxWidth="none" disablePadding>
      <Container maxWidth="xl">
        <Box cx={{ pB: '7', pT: '6' }}>
          <Grid cx={{ pB: '7', rowGap: '5' }}>
            <Grid.Col xs={7} md={3}>
              <Logotype />
            </Grid.Col>
            <Grid.Col offsetMd={6} md={3}>
              <Flex cx={{ columnGap: '2', justifyContent: { desktop: 'end' } }}>
                {partnerMultiple?.partnerMultiple.map((partner: any) => {
                  return (
                    <Btn key={partner.id} {...partner.linkCta} variant="link">
                      <Image
                        alt="partner-logo"
                        {...partner.logo}
                        fixedRatio
                        style={{ height: '72px', width: 'auto' }}
                      />
                    </Btn>
                  );
                })}
              </Flex>
            </Grid.Col>
          </Grid>
          <FooterEntries items={footerNav?.items} />
        </Box>
      </Container>
      <hr className={styles.line} />
      <Container maxWidth="xl">
        <FooterBar items={extrasNav?.items} linkedin={linkedin} />
      </Container>
    </Container>
  );
}
